/* global flatpickr */
'use strict'
const formHelper = {
	el: {
		checkboxes: document.querySelectorAll('.js-checkbox'),
		inputsDate: document.querySelectorAll('.js-date'),
		formsGPF: document.querySelectorAll('.forms-gpf form'),
		forms: document.querySelectorAll('.js-form'),
		inputs: document.querySelectorAll('.form__input'),
		body: document.body,
		inputsRadioToggleField: document.querySelectorAll('.js-toggle-field')
	},

	fxFormToJson: function formToJson(elem) {
		let unindexedArray = $(elem).serializeArray()
			, indexedArray = {}
		$.map(unindexedArray, function(n, i) {
			$(n).each(function() {
				n.value === 'true' || n.value === 'false' ? n.value = JSON.parse(n.value) : ''
			})
			indexedArray[n['name']] = n['value']
		})
		return indexedArray
	},

	fxAcceptOnlyNumbers (e) {
		const input = e.currentTarget
		let key = e.charCode ? e.charCode : e.keyCode

		if(key < 48 || key > 57) e.preventDefault()

		if (input.value.length == 1 || input.value.length == 4) {
			input.value = `${input.value}${String.fromCharCode(key)}-`
			e.preventDefault()
		}
	},

	fxShowLoader (form) {
		if ($(form).valid()) {
			$('.spinner-overlay').css('display', 'flex')
			this.el.body.classList.add('no-scroll-hidden')
		}	
	},

	fxRemoveLoader () {
		$('.spinner-overlay').css('display', 'none')
		this.el.body.classList.remove('no-scroll-hidden')
	},

	fxLabelActive (parent) {
		let classes = ['is-active', 'is-completed']
		parent.classList.add(...classes)
	},

	fxLabelInactive (input, parent) {
		input.value === '' && parent.classList.remove('is-completed')
		parent.classList.remove('is-active')
	},

	fxCheckInputValues (input, parent) {
		if(input.value?.length) {
			let classes = ['is-active', 'is-completed']
			parent.classList.add(...classes)
		}
	},

	fxAutofill (el, parent, animationName) {
		switch(animationName) {
			case 'onAutoFillStart':
				console.log('autoFill active')
				this.fxLabelActive(parent)
				break
			case 'onAutoFillCancel':
				console.log('autoFill inactive')
				this.fxLabelInactive(el, parent)
				break
		}
	},

	fxToggleDisplayStep(btn) {
		const resultContainer = btn.closest('.js-step'),
			targetContainer = document.querySelector(`${btn.dataset.target}`),
			wrapper = resultContainer.parentElement,
			wrapperHeight = wrapper.offsetHeight

		wrapper.style.height = `${wrapperHeight}px`

		$(resultContainer).fadeOut(200)

		setTimeout(() => {
			targetContainer.classList.remove('d-none')
			$(targetContainer).fadeIn(200)
			wrapper.style.removeProperty('height')
		}, 200)
	},

	fxToggleField(el) {
		const targetField = document.getElementById(`${el.dataset.target}`) 

		el.value === el.dataset.value ? targetField.classList.remove('d-none') :  targetField.classList.add('d-none')
	},

	fxInputEvents() {
		for (const checkbox of this.el.checkboxes)
			checkbox.addEventListener('change', e => e.currentTarget.value = e.currentTarget.checked ? 'true' : 'false')

		for (const input of this.el.inputsDate) {
			// input.addEventListener('keydown', e => {
			// 	let keys = [8, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 229]
			// 	!keys.includes(e.which) ? e.preventDefault() : ''
			// })
			input.addEventListener('keypress', e => {
				this.fxAcceptOnlyNumbers(e)
			})
		}

		for (const form of this.el.formsGPF) {
			form.addEventListener('submit', e => {
				this.fxShowLoader(e.currentTarget)
			})
		}

		for (const form of this.el.forms) {
			form.addEventListener('submit', e => {
				this.fxShowLoader(e.currentTarget)
			})
		}

		for (const radio of this.el.inputsRadioToggleField) {
			radio.addEventListener('change', e => {
				this.fxToggleField(e.currentTarget)
			})
		}

		//-label animations on focus/focusout, initial state if input has value
		for(const input of this.el.inputs) {
			const parent = input.parentElement

			//-on focus
			input.addEventListener('focus', e => this.fxLabelActive(parent))

			//-on focus out
			input.addEventListener('focusout', e => this.fxLabelInactive(e.currentTarget, parent))

			//-initial state
			this.fxCheckInputValues(input, parent)

			//autofill
			input.addEventListener('animationstart', e => this.fxAutofill(e.currentTarget, parent, e.animationName))
		}
	},

	init() {
		this.fxInputEvents()
	}
}

formHelper.init()